import React from 'react';
import { observer } from 'mobx-react';
import { WeaDatePicker } from 'ecCom';

interface Props {
    value?: string;
    valueSpan?: string;
    viewAttr:string;
    onChange: (string) => void;
    ecId?:string;
}

export default observer((props: Props) => {
    const {  value,onChange,viewAttr } = props;
    return (
        <div style={{float:'left'}}>
            <WeaDatePicker ecId={`${props && props.ecId || ''}_WeaDatePicker@znt133`} noInput
                showTime
                viewAttr={viewAttr}
                format="yyyy-MM-dd HH:mm"
                value={value}
                onChange={onChange}
            />
        </div>
    )
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/littleCard/table-cell/WeaDateTimePicker.tsx